import jwt from "jsonwebtoken";
import React from "react";
import { Redirect, Route, useLocation } from "react-router-dom";

function PrivateRoute({ component: Component, path, ...rest }) {
  let user;
  const token = localStorage.getItem("token");
  if (token) {
    user = jwt.verify(token, "success");
  }

  const { search } = useLocation();
  return (
    <Route
      path={path}
      {...rest}
      render={(props) =>
        token && user.iat ? (
          <Component {...props} user={user} />
        ) : (
          <Redirect
            to={{
              pathname: "/auth/signin",
              state: {
                search: search,
                prevLocation: props.location.pathname,
              },
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
